import styled from 'styled-components';
import { Image } from 'react-bootstrap';

export const CalendarIcon = styled(Image)`
  cursor: pointer;
`;
